<template>
    <div class="w-full flex ">
        <p class="text-left text-base text-gray-500 pt-4">
            No Favorite Points Found.  Favorite points by clicking the star while viewing a points graph.
        </p>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

export default {
    name: "NoFavoritePoints",
    mixins: [SonicuCoreMixin],
    components: {},
    props: {

    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
    
    },
    watch: {

    },
    computed: {
    
    },
}

</script>

<style scoped>

</style>